import { inject } from '@angular/core';
import { Router, CanMatchFn } from '@angular/router';

import { AuthService } from '@/app/core/services/auth/auth.service';

export const NfcRedirectGuard: CanMatchFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.hasToken()) {
    return true;
  }

  const navigation = router.getCurrentNavigation();
  const targetUrlTree = navigation?.extractedUrl;
  const nfcId = targetUrlTree?.queryParams['nfc_id'];

  if (!nfcId) {
    return true;
  }

  return router.createUrlTree(['/products'], {
    queryParams: { nfc_id: nfcId },
  });
};
